function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23 18.333c0 .509-.21.996-.586 1.356-.375.36-.884.561-1.414.561H3c-.53 0-1.04-.202-1.414-.561A1.88 1.88 0 0 1 1 18.333V7.792c0-.509.21-.996.586-1.356.375-.36.884-.561 1.414-.561h4L9 3h6l2 2.875h4c.53 0 1.04.202 1.414.561.375.36.586.847.586 1.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 16.417c2.21 0 4-1.717 4-3.834S14.21 8.75 12 8.75s-4 1.716-4 3.833 1.79 3.834 4 3.834"
  }));
};
export default SvgCamera;